import { Component } from 'react';

import { datadogLogs } from '@datadog/browser-logs';

import { GenericError } from '@src/components/GenericError/GenericError';

export class ErrorBoundary extends Component<
    { children: React.ReactNode },
    { hasError: boolean }
> {
    state = { hasError: false };

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        this.setState({ hasError: true });
        datadogLogs.logger.error(error.message, { info });
    }

    render() {
        if (this.state.hasError) {
            return <GenericError />;
        }
        return this.props.children;
    }
}
